<template>
  <div>
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <template v-slot:activator="{ on, attrs }">
        <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-title>Sync Balance</v-list-item-title>
        </v-list-item>
      </template>
      <v-card v-if="dialog" class="pa-4" color="primary" dark>
        <v-card-text>
          <span class="white--text">Re-syncing Donor Balance</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0 mt-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import donorService from "@/modules/Donors/service.js";

export default {
  props: ["DonorId"],
  data() {
    return {
      dialog: false,
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.syncBalance();
      }
    },
  },
  methods: {
    syncBalance() {
      return donorService.syncBalance(this.DonorId).then(() => {
        this.$events.emit("customerProfileEvent");
         this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "success",
            title: "Balance Updated!",
          });
        this.dialog = false;
      });
    },
  },
};
</script>
